import { useQuery } from '@tanstack/react-query';
import { rolesClient } from 'api/AdgangClients';
import { ResourceFilter, UserType } from 'api/adgang';
import { SelectOption } from 'common.ui';

export function useRolesQuery(params: {
  userType?: UserType;
  applicationIds?: string[];
  resourceFilter?: ResourceFilter;
}) {
  return useQuery({
    queryKey: ['roles', params],
    queryFn: async () => {
      const applicationIds = params.applicationIds ?? [];
      const res = await rolesClient.apiRolesSearchesPost({
        roleSearchRequest: {
          paginationQuery: { pageNumber: 1, pageSize: 9999 },
          userType: params.userType,
          applicationFilter: {
            applicationIds: applicationIds.filter((a) => a !== 'global'),
            includeGlobalValues: applicationIds.includes('global')
          },
          resourceFilter: params.resourceFilter
        }
      });

      return (res.data ?? [])
        .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))
        .map((d) => ({ id: d.roleId?.toString(), text: d.name }) as SelectOption);
    },
    staleTime: 5 * 60 * 1000
  });
}
